<script setup>
import { watch, ref, onMounted } from 'vue';
import { storeToRefs } from "pinia";
import datePicker from '../shared/date-picker.vue';
import { useFVStore } from '../../stores/formvibes';
import { getFromLocalStorage, setToLocalStorage } from '../../stores/utils';
import { PieChart, Refresh, TrendCharts, Histogram } from '@element-plus/icons-vue';

const store = useFVStore();
const selectedChart = ref('bar');
const props = defineProps(['getAnalyticsData', 'chartType', 'changeChartType']);
const { formsSelector, generalStates, isNoPlugins, isPro, dates } = storeToRefs(store);

const forms = formsSelector.value;
const selectedForm = ref(getFromLocalStorage('fv-form'));
const selectedFilter = ref(getFromLocalStorage('fv-analytics-filter') || 'month');

onMounted(() => {
    if(!selectedForm.value){
        const firstplugin = forms[0]?.label;
        const firstform = forms[0]?.options[0]?.value;
        selectedForm.value = firstform;
        generalStates.value.queryParams = {
            ...generalStates.value.queryParams,
            plugin: firstplugin,
            formid: firstform,
        }
    }
});
watch([selectedChart], () => {
    props.changeChartType(selectedChart);
    setToLocalStorage('fv-chart-type', selectedChart);
});

// watch([dates], () => {
//     props.getAnalyticsData();
// })

watch([selectedFilter], () => {
    setToLocalStorage('fv-analytics-filter', selectedFilter.value);
    generalStates.value = {
        ...generalStates.value,
        queryParams: {
            ...generalStates.value.queryParams,
            filter_type: selectedFilter.value
        }
    }

    props.getAnalyticsData();
})

const onChangeForm = (id, e) => {
    const form = forms.filter((form) => form.label === e.label)[0].options.filter((fm) => fm.value === id)[0];
    const plugin = form.plugin;
    const formid = form.value;
    setToLocalStorage('fv-form', form);
    generalStates.value = {
        ...generalStates.value,
        queryParams: {
            ...generalStates.value.queryParams,
            plugin:
                plugin || (forms?.length > 0 ? forms[0]?.options[0]?.plugin : []),
            formid:
                formid || (forms?.length > 0 ? forms[0]?.options[0]?.value : []),        
        }
    }

    props.getAnalyticsData();
}

</script>
<template>
    <div class="fv-content-wrapper fv-action-bar-wrapper">
        <div class="fv-page-title">
            <h3>Analytics</h3>
        </div>
        <div class="fv-action-bar">
            <div class="fv-analytics-controls left">
                <datePicker />
                <!-- Form Drop Down -->
                <el-select v-model="selectedForm" placeholder="Select">
                    <el-option-group
                        v-for="group in forms"
                        :key="group.label"
                        :label="group.label"
                        >
                        <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @click="(e) => onChangeForm(item.value,group)"
                        />
                    </el-option-group>
                </el-select>
            </div>
            <div class="fv-analytics-controls right">
                
                <el-icon size="20" @click="selectedChart = 'bar'" :class="{'active' : selectedChart == 'bar' }" class="fv-anyltics-chart"><Histogram /></el-icon>
                <el-icon size="20" @click="selectedChart = 'line'" :class="{'active' : selectedChart == 'line' }" class="fv-anyltics-chart"><TrendCharts /></el-icon>
                <el-icon size="20" @click="getAnalyticsData()"><Refresh /></el-icon>
                <el-select v-model="selectedFilter" placeholder="Select">
                    <el-option label="By Day" value="day">
                        <!-- <el-icon ></el-icon> -->
                        <span>By Day</span>
                    </el-option>
                    <el-option label="By Week" value="week">
                        <!-- <el-icon ></el-icon> -->
                        <span>By Week</span>
                    </el-option>
                    <el-option label="By Month" value="month">
                        <!-- <el-icon ></el-icon> -->
                        <span>By Month</span>
                    </el-option>
            </el-select>
            </div>
        </div>
    </div>
</template>